<template>
  <div class="code-box">
    <p class="login-code-title">
      <slot name="title"></slot>
    </p>
    <p class="login-code-subtitle">
      <slot name="subtitle"></slot>
    </p>
    <p class="login-code-desc">
      <slot name="desc"></slot>
    </p>
    <p class="login-code-info">
      <span class="login-code-phone">
        <slot name="info"></slot>
      </span>
      <span class="login-code-other">
        <slot name="other"></slot>
      </span>
    </p>
    <div v-if="!showSuccessInfo">
      <div class="login-code-input">
        <input
          v-for="(item, index) in captchas"
          :key="index"
          :value="item.num"
          :id="'captcha' + index"
          @focus="e => adjust(e, index)"
          @keyup="e => inputDirection(e, index)"
          class="captcha_input_box"
          type="tel"
          selection-start="0"
          selection-end="1"
          maxlength="1"
          @paste.prevent="e => handlePaste(e, index)"
        />
      </div>
      <!-- 测试文本 -->
      <!-- <p class="error-message">Code not recognised, please try again</p> -->
      <p v-if="errMsg && inputCompeted" class="error-message">{{ errMsg }}</p>
      <div class="login-code-button">
        <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
          <div v-if="!loading" @click="handleDone" role="button">
            {{ $i18n.t('btn-done') }}
          </div>
          <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
        </div>
        <span class="login-code-resend" role="link">
          <span>{{ $i18n.t('code-auth-nocode') }}</span>
          <a class="resend" @click="handleResend">&nbsp;{{ $i18n.t('code-auth-resend') }}</a>
        </span>
        <!-- <span v-if="isShowAsk" class="ask-me-later" @click="handleCodeLater">
          {{ $i18n.t('code-auth-ask-later') }} >
        </span> -->
        <span v-if="bottomline" class="login-line"></span>
      </div>
    </div>
    <div v-if="showSuccessInfo">
      <div class="success-info">
        <img src="@/components/LeftAccount/images/icon-verifyed.svg" alt="success" />
        <p>{{ $i18n.t('code-auth-thanks') }}</p>
      </div>
    </div>
    <div v-if="isResendSuccess">
      <div class="notify-box">
        <img src="~img/icon-check-white.svg" alt="resend success" />
        <span>{{ $i18n.t('code-auth-sent') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Captcha',
    props: {
      isShowAsk: {
        type: Boolean,
        default: false,
      },
      bottomline: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      errMsg: {
        type: String,
        default: '',
      },
    },
    beforeUnmount() {
      this.showSuccessInfo = false;
    },
    mounted() {
      this.isShowAsk || this.notify();
    },
    data() {
      return {
        activeInput: 0,
        loginDisable: true,
        captchas: [{ num: '' }, { num: '' }, { num: '' }, { num: '' }, { num: '' }, { num: '' }],
        inputCompeted: false,
        showSuccessInfo: false,
        isResendSuccess: false,
      };
    },
    methods: {
      handleDone() {
        if (this.loginDisable) return;
        const code = this.captchas.map(x => x.num).join('');
        this.$emit('handleDone', code);
      },
      showSuccess(cb) {
        this.showSuccessInfo = true;
        setTimeout(() => {
          cb && cb();
        }, 2000);
      },
      notify() {
        // animation
        this.isResendSuccess = true;
        setTimeout(() => {
          this.isResendSuccess = false;
        }, 2000);
      },
      handleResend() {
        // 清空
        this.captchas = [
          { num: '' },
          { num: '' },
          { num: '' },
          { num: '' },
          { num: '' },
          { num: '' },
        ];
        this.activeInput = 0;
        this.$emit('handleResend', this.notify);
      },
      // 自动校准输入顺序
      adjust(e, index) {
        const dom = document.getElementById(`captcha${this.activeInput}`);
        if (index !== this.activeInput && dom) {
          dom.focus();
        }
      },
      // 控制前后方向
      inputDirection(event, index) {
        // console.log(event, 'event', index);
        // input框改变前的值
        const preValue = this.captchas[index].num;
        // 现在的值
        const currentValue = event.target.value.trim();
        this.captchas[index].num = currentValue;
        // 回退键处理
        if (event.keyCode === 8 && currentValue === '') {
          if (index === 0) return;
          const dom = document.getElementById(`captcha${index - 1}`);
          if (preValue) {
            // console.log('1回退');
            this.captchas[index].num = '';
            this.activeInput = index;
          } else {
            // console.log('2回退');
            this.captchas[index - 1].num = '';
            this.activeInput = index - 1;
          }
          if (dom) dom.focus();
        }
        if (event.keyCode !== 8 && currentValue !== '' && index !== this.captchas.length - 1) {
          const dom = document.getElementById(`captcha${index + 1}`);
          this.activeInput = index + 1;
          // console.log('1增加');
          if (dom) dom.focus();
        }
        if (index === this.captchas.length - 1) {
          const code = this.captchas.map(x => x.num).join('');
          if (code.length === 6) {
            this.inputCompeted = true;
            this.loginDisable = false;
            this.$emit('handleFinish', code);
          } else {
            this.inputCompeted = false;
            this.loginDisable = true;
          }
        }
      },
      // 输入框相互联动
      inputFinash(e, index) {
        // 赋值
        const last = this.captchas[index].num;
        console.log(last);
        const inputvalue = e.target.value.trim();
        this.captchas[index].num = inputvalue;
        // 针对最后一个input框的回退键的处理
        if (last) {
          this.captchas[index].num = '';
        }
        if (index === this.captchas.length - 1) {
          const code = this.captchas.map(x => x.num).join('');
          if (code.length === 6) {
            this.inputCompeted = true;
            this.loginDisable = false;
            this.$emit('handleFinish', code);
          } else {
            this.inputCompeted = false;
            this.loginDisable = true;
          }
        }
      },
      handlePaste(e, index) {
        // 获取剪贴板中的文本，并根据长度截取为 6 个字符
        const clipboardText = e.clipboardData.getData('text');
        const pasteCode = clipboardText.substring(0, 6).split('');
        // 将剪贴板中的文本粘贴到对应的输入框中
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < pasteCode.length; i++) {
          if (index + i <= 5) {
            this.captchas[index + i].num = pasteCode[i];
          }
        }
        // 自动聚焦到下一个输入框
        if (index < 5) {
          const currentActive = index + pasteCode.length;
          this.activeInput = currentActive > 5 ? 5 : currentActive;
          const dom = document.getElementById(`captcha${this.activeInput}`);
          if (dom) dom.focus();
        }
      },
      handleCodeLater() {
        this.$emit('handleSkip');
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use '@/assets/css/variables.scss' as *;
  .code-box {
    color: #000000;
  }
  .login-code-title {
    @include font(32px, 700);
    line-height: 48px;
    margin-bottom: 30px;
    text-align: center;
    color: #163049;
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(img) {
      width: 24px;
      height: 30px;
      margin-right: 10px;
    }
  }

  .login-code-subtitle {
    width: 450px;
    margin: 0 auto;
    @include font(18px, 700);
    line-height: 1.5;
    /* prettier-ignore */
    font-size: min(14Px);
    margin-bottom: 9px;
    text-align: center;
    color: #163049;
  }

  .login-code-desc {
    width: 450px;
    margin: 0 auto;
    @include font(18px, 400);
    /* prettier-ignore */
    font-size: min(14Px);
    line-height: 1.5;
    margin-bottom: 9px;
    text-align: center;
    color: #163049;
  }

  .login-code-info {
    width: 450px;
    margin: 0 auto;
    @include font(18px, 400);
    /* prettier-ignore */
    font-size: min(14Px);
    margin-bottom: 9px;
    text-align: center;
    color: #163049;
    .login-code-phone {
      @include font(18px, 600);
      /* prettier-ignore */
      font-size: min(14Px);
    }
    .login-code-other {
      @include font(18px, 400);
      /* prettier-ignore */
      font-size: min(14Px);
    }
  }

  .login-code-input {
    width: 450px;
    margin: 55px auto 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .captcha_input_box {
      width: 12%;
      height: 70px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      border: 1.5px solid #9eacb5;
      @include font(34px, 700);
      text-align: center;
      color: #1e243a;
    }
  }

  .login-code-button {
    width: 450px;
    margin: 40px auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .login-code-resend {
      margin: 25px 0 16px;
      margin-right: auto;
      margin-left: auto;
      line-height: 35px;
      text-align: center;
      text-decoration: unset;
      color: #163049;

      @include font(18px, 400);
      /* prettier-ignore */
      font-size: min(14Px);

      .resend {
        @include font(18px, 700);
        /* prettier-ignore */
        font-size: min(14Px);
        line-height: 35px;
      }
    }

    .ask-me-later {
      color: #163049;
      cursor: pointer;
      @include font(20px, 600);
      /* prettier-ignore */
      font-size: min(14Px);
      text-align: center;
    }

    .login-line {
      position: absolute;
      bottom: -55px;
      left: 50%;
      width: 100%;
      border-bottom: 1px solid #9eacb5;
      transform: translateX(-50%);
    }
  }

  .login-code-bottom {
    width: 450px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;

    .email-logo {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }

    .login-code-toemail {
      @include font(18px, 700);
      color: #163049;
      line-height: 35px;
    }
  }

  .login-btn {
    @include font(24px, 600);
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #fff;
    text-align: center;
    background: $color-glod-radient;
    border-radius: 10px;

    &-disable {
      cursor: not-allowed;
      background: #9eacb5;
    }
  }

  .error-message {
    @include font(20px, 400);

    width: 450px;
    text-align: center;
    margin: 0 auto;
    margin-top: 16px;
    line-height: 27px;
    color: #c22;
    word-wrap: break-word;
    //word-break: break-all;
  }

  .success-info {
    margin: 40px 0px;
    text-align: center;
    @include font(34px, 600);

    img {
      width: 120px;
      height: 120px;
      margin-bottom: 30px;
    }

    p {
      color: #378523;
    }
  }

  .notify-box {
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    left: 50%;
    background-color: #163049;
    width: 172px;
    height: 45px;
    border-radius: 0px 0px 10px 10px;
    color: #ffffff;
    @include font(20px, 600);
    line-height: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 1024px) {
    .login-code-title,
    .login-code-subtitle,
    .login-code-desc,
    .login-code-info {
      width: 100%;
    }
    .login-code-input {
      width: 100%;
    }

    .login-code-button {
      width: 100%;
    }

    .login-code-bottom {
      width: 100%;
    }

    .error-message {
      width: 100%;
    }
  }
</style>
